import { IDataPointExt, ISeries } from 'app/components/data/DataChart/interfaces'
import { JsonPathExpressionType } from 'app/components/data/utils/ObjectParser/interfaces'
import * as JSONPath from 'jsonpath-plus'

class ObjectParser {
  static Query<T>(json: any, path: JsonPathExpressionType): T[] {
    return JSONPath({ json, path }) as T[]
  }

  static QueryAndGetFirst<T>(json: any, path: JsonPathExpressionType): T {
    let first = JSONPath({ json, path })[0]

    if (first && !isNaN(first)) {
      first = Number(first)
    }

    return first as T
  }

  static QueryWithLoop<T>(json: any, path: JsonPathExpressionType, startIndex: number, endIndex: number): T[] {
    const resolves: T[] = []

    for (let i = startIndex; i <= endIndex; i++) {
      const indexRegex = new RegExp('(\\[i\\])', 'g')
      const newPath = path.replace(indexRegex, `[${i}]`)

      resolves.push(ObjectParser.QueryAndGetFirst(json, newPath))
    }

    return resolves
  }

  static QueryISeriesWithLoop(jsons: any[], series: ISeries) {
    const seriesCopy = { ...series }

    if (seriesCopy.dataExpression) {
      seriesCopy.data = ObjectParser.Query(jsons, seriesCopy.dataExpression)
    } else {
      const dataIsArray = Array.isArray(seriesCopy.data) && seriesCopy.data.length > 0
      const dataHasDataPoints = dataIsArray && Object.isObject(seriesCopy.data[0]) && !Array.isArray(series.data[0])

      if (dataHasDataPoints) {
        let newSeriesData: IDataPointExt[] = []

        seriesCopy.data.forEach((dataPoint: IDataPointExt) => {

          if (dataPoint.loop) {
            const dataPointsArr: IDataPointExt[] = []

            // tslint:disable-next-line:prefer-for-of
            for (let i = 0; i < jsons.length; i++) {
              dataPointsArr.push({ ...dataPoint })
            }

            if (dataPoint.xExpression) {
              const xResolves = ObjectParser.QueryWithLoop<number>(jsons, dataPoint.xExpression, 0, jsons.length - 1)
              xResolves.forEach((x, i) => {
                dataPointsArr[i].x = x
              })
            }

            if (dataPoint.yExpression) {
              const yResolves = ObjectParser.QueryWithLoop<number>(jsons, dataPoint.yExpression, 0, jsons.length - 1)
              yResolves.forEach((y, i) => dataPointsArr[i].y = y)
            }

            if (dataPoint.zExpression) {
              const zResolves = ObjectParser.QueryWithLoop<number>(jsons, dataPoint.zExpression, 0, jsons.length - 1)
              zResolves.forEach((z, i) => dataPointsArr[i].z = z)
            }

            if (dataPoint.nameExpression) {
              const nameResolves = ObjectParser.QueryWithLoop<string>(jsons, dataPoint.nameExpression, 0, jsons.length - 1)
              nameResolves.forEach((name, i) => dataPointsArr[i].name = name)
            }

            if (dataPoint.colorExpression) {
              const colorResolves = ObjectParser.QueryWithLoop<string>(jsons, dataPoint.colorExpression, 0, jsons.length - 1)
              colorResolves.forEach((color, i) => dataPointsArr[i].color = color)
            }

            newSeriesData = newSeriesData.concat(dataPointsArr)

          } else {
            if (dataPoint.xExpression) {
              dataPoint.x = ObjectParser.QueryAndGetFirst(jsons, dataPoint.xExpression)
            }

            if (dataPoint.yExpression) {
              dataPoint.y = ObjectParser.QueryAndGetFirst(jsons, dataPoint.yExpression)
            }

            if (dataPoint.zExpression) {
              dataPoint.y = ObjectParser.QueryAndGetFirst(jsons, dataPoint.zExpression)
            }

            if (dataPoint.nameExpression) {
              dataPoint.name = ObjectParser.QueryAndGetFirst(jsons, dataPoint.nameExpression)
            }

            newSeriesData.push(dataPoint)
          }
        })

        seriesCopy.data = newSeriesData
      }
    }

    return seriesCopy
  }
}

export {
  ObjectParser
}



// WEBPACK FOOTER //
// ./src/app/components/data/utils/ObjectParser/index.ts